import { Box } from "@chakra-ui/react";
import React, { ReactNode } from "react";

export default function LayoutWithTable({ children }: { children: ReactNode }) {
  return (
    <Box px="20px" min-height="calc(100vh - 45px)">
      {children}
    </Box>
  );
}
